module.exports = __webpack_public_path__ + "img/MGH-Roppongi-11-2440x1172.d067d0e9.jpg";